import { TopLogoControllerFg } from "@quest/murka-games-behavior-panther/dist/Game/TopLogo/TopLogoControllerFg";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { dispatcher } from "@quest/base-core";

export class TopLogoControllerFgGame extends TopLogoControllerFg{
// Overrided to subscribe game end events
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.TOP_LOGO_HIDE_ON_BIG_WIN_FG, this.topLogoHideOnBigWinFg, this);
    dispatcher.on(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN_FG, this.topLogoShowOnBigWinFg, this);
  }
        // Overrided to unsubscribe game end events
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.TOP_LOGO_HIDE_ON_BIG_WIN_FG, this.topLogoHideOnBigWinFg, this);
    dispatcher.off(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN_FG, this.topLogoShowOnBigWinFg, this);
  }

  // Add to hide portrait logo on big win
  private topLogoHideOnBigWinFg(): void {
    this.view.getContainerByID("topLogoContainer").visible = false;
  }

  // Add to show portrait logo on big win
  private topLogoShowOnBigWinFg(): void {
    this.view.getContainerByID("topLogoContainer").visible = true;
  }
}